<template>
  <div class="grid grid-cols-12 gap-x-10 mt-8 mb-5">
    <div class="col-span-12">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i>{{ title }}</h5>
      </div>
      <vs-table class="mt-5" v-model="selectCompany" @selected="handleSelected" pagination :data="list">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th>{{ $t('구분') }}</vs-th>
          <vs-th>{{ $t('업체명') }}</vs-th>
          <vs-th>{{ $t('대표자') }}</vs-th>
          <vs-th>{{ $t('담당자') }}</vs-th>
          <vs-th v-if="isInspector">{{ $t('시설물 점검자') }}</vs-th>
          <vs-th>{{ $t('연락처') }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ data[indextr].id }}</vs-td>
            <vs-td> {{ data[indextr].com_type }}</vs-td>
            <vs-td> {{ data[indextr].com_name }}</vs-td>
            <vs-td> {{ data[indextr].com_ceo }}</vs-td>
            <vs-td> {{ data[indextr].director }}</vs-td>
            <vs-td v-if="isInspector"> {{ data[indextr].inspector }}</vs-td>
            <vs-td> {{ data[indextr].phone }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div v-if="showDetail" class="col-span-12">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i>{{ detailTitle }}</h5>
      </div>
      <div class="mt-5">
        <div class="grid grid-cols-12 gap-x-6 gap-y-4">
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('구분') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.com_type" :readonly="true" />
          </div>
          <div class="col-span-4"></div>
          <div class="col-span-4"></div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('업체명') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.com_name" :readonly="true" />
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('대표자') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.com_ceo" :readonly="true" />
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('사업자등록번호') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.com_number" :readonly="true" />
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('주소') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.com_address" :readonly="true" />
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('업태') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.com_business_class" :readonly="true" />
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('업종') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.com_business_type" :readonly="true" />
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('담당자') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.director" :readonly="true" />
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('연락처') }}</div>
            <ml-input class="w-full flex-1" v-model="selectCompany.phone" :readonly="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
export default {
  name: "CompanyCompanyList",
  components: { DateSelector },
  props: {
    title: {
      type: String,
      default: () => "사업장별 업체 정보",
    },
    detailTitle: {
      type: String,
      default: () => "업체 세부 정보",
    },
    list: {
      type: Array,
      default: () => [],
    },
    showDetail: {
      type: Boolean,
      default: () => true,
    },
    isInspector: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectCompany: {},
    };
  },
  methods: {
    getDate(date) {
      if (date) {
        return new Date(date).format("yyyy-MM-dd");
      }
      return "";
    },
    handleSelected(tr) {
      this.$emit("select", tr);
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
